import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllAttendanceSessionPDFJobsResponse {
  success: boolean;
  total: number;
  jobs: Array<Job>;
}

export interface Job {
  jobId: string;
  sessionId: string;
  sessionName: string | null;
  type: 'pdf' | 'csv';
  status: 'queued' | 'processing' | 'completed' | 'failed';
  progress: number;
  downloadUrl: string | null;
  totalClasses: number;
  processedClasses: number;
  failedClasses: number;
  completedAt: string | null;
  createdAt: string;
  error?: string;
}

export const getAllAttendanceSessionPDFJobsAPI = async () => {
  const response = await baseAPI.get<GetAllAttendanceSessionPDFJobsResponse>(
    `/attendance/session-all-jobs`,
  );
  return response.data;
};

export const getAllAttendanceSessionPDFJobsQueryOptions = () =>
  queryOptions({
    queryKey: [KEYS.ATTENDANCE_SESSION_PDF_JOBS, 'all'],
    queryFn: getAllAttendanceSessionPDFJobsAPI,
  });

export const useGetAllAttendanceSessionPDFJobs = () => {
  return useQuery(getAllAttendanceSessionPDFJobsQueryOptions());
};
